// extracted by mini-css-extract-plugin
export default {"questionBox":"SanctionedCountryQuestions_questionBox__J4Ii3"};